import NiceModal, { useModal } from '@ebay/nice-modal-react';

import { useState } from 'react';

import Button from 'components/field/Button';
import StringInput from 'components/field/StringInput';
import SwitchInput from 'components/field/SwitchInput';
import Form from 'components/form/Form';
import FormItem from 'components/form/FormItem';
import Modal from 'components/global/Modal';
import Typography from 'components/global/Typography';
import { ModalActions, ModalContent, ModalTitle } from 'components/global/styled/Modal.styled';

import useAlert from 'hooks/useAlert';
import useAxiosPrivate from 'hooks/useAxiosPrivate';

import { ADVANCE_WMS_MODULE } from 'services/consts';

import AppLogger from 'utils/AppLogger';

const CreateZoneWave = NiceModal.create(({ ids, whID }) => {
	const defaultColSpan = {
		md: 6
	};

	const { showError, showSuccess } = useAlert();

	const [isLoading, setIsLoading] = useState(false);
	const [waveNumber, setWaveNumber] = useState('');
	const [sortingRequirement, setSortingRequirement] = useState(true);

	const modal = useModal();
	const axios = useAxiosPrivate();

	const handleCloseModal = () => modal.remove();

	const handleSubmit = async () => {
		setIsLoading(true);
		try {
			const resp = await axios.post(ADVANCE_WMS_MODULE.CREATE_ZONE_WAVE, {
				ids,
				whId: whID,
				sortingRequirement: sortingRequirement.toString()
			});
			if (
				resp.data.success &&
				(!resp.data.failedIds ||
					(resp.data.failedIds && Array.isArray(resp.data.failedIds) && resp.data.failedIds.length === 0))
			) {
				showSuccess();
				if (resp.data.waves && Array.isArray(resp.data.waves)) {
					let result = '';
					resp.data.waves.forEach((wave) => (result += `${wave.waveNumber},`));
					if (result.length > 0) result = result.slice(0, -1);
					setWaveNumber(result);
				}
			} else {
				showError({ message: 'errorMsg.cannotCreateWaveForSomeItems' });
			}
		} catch (error) {
			AppLogger.error(error);
			showError({
				header: 'error',
				message: 'errorMsg.ordersInvalidToCreateWave'
			});
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<Modal fullwidth maxWidth="small">
			<ModalTitle>
				<Typography variant="p1">createZonePickingWave</Typography>
			</ModalTitle>
			<ModalContent>
				<Form>
					<FormItem colSpan={defaultColSpan} label="waveNumbersCreated" isLoading={isLoading} required>
						<StringInput disabled value={waveNumber} />
					</FormItem>
					<FormItem colSpan={defaultColSpan} label="sortingNeeded" isLoading={isLoading}>
						<SwitchInput
							value={sortingRequirement}
							setValue={() => setSortingRequirement(!sortingRequirement)}
						/>
					</FormItem>
				</Form>
			</ModalContent>
			<ModalActions>
				<Button label={'cancel'} variant="outline" onClick={handleCloseModal} />
				<Button label={'submit'} loading={isLoading} onClick={handleSubmit} disabled={!!waveNumber} />
			</ModalActions>
		</Modal>
	);
});

export default CreateZoneWave;
